import { param, route } from "./router";

export const HOME = route();

export const COLLECTION = route().path(
  param("collectionName").oneOf(["phantoms"]).required(true)
);

export const STDIO = route("stdio");
